import React, { useContext, useMemo } from 'react'

import CarouselCTACard from '../Bookmark/Carousels/CarouselCTACard'
import ExperienceItemCarousel from '../Bookmark/Carousels/ExperienceItemCarousel'
import ExperienceSearchModalCTA from '../TripSummary/CallToActionButtons/Experience/ExperienceSearchModalCTA'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'components/Luxkit/Button/TextButton'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useExperienceSearch from 'hooks/Experiences/useExperienceSearch'
import useToggle from 'hooks/useToggle'
import { SectionIdContext } from 'tripPlanner/contexts/SectionIdProvider'
import { useLEPlaceByCoordinates } from 'tripPlanner/hooks/api'

type Props = {
  lat: number
  lng: number
  tripId: string
  className?: string
}

function ViewNearbyExperiencesCta({ lat, lng, tripId, className }: Props) {
  const { value: modalVisible, on: showModal, off: hideModal } = useToggle()

  const { data: place } = useLEPlaceByCoordinates(lat, lng)
  const sectionId = useContext(SectionIdContext)

  const [list, experiences] = useExperienceSearch({
    placeId: place?.id,
    limit: 3,
  })

  const isLoading = (!list || list.fetching) && !list?.error

  const experienceIds = useMemo(
    () => (experiences ?? []).map((e) => e?.id).filter((s): s is string => !s),
    [experiences],
  )

  return (
    <>
      <Modal
        isOpen={modalVisible}
        title="Recommended Offers"
        onClose={hideModal}
        size="large"
      >
        <VerticalSpacer gap={16}>
          {isLoading && (
            <BodyText
              align="center"
              colour="neutral-one"
              variant="large"
              weight="bold"
            >
              Finding the best offers for you
            </BodyText>
          )}
          {!isLoading && experienceIds.length === 0 && (
            <BodyText
              align="center"
              colour="neutral-one"
              variant="large"
              weight="bold"
            >
              Sorry, we can't find any experiences nearby
            </BodyText>
          )}
          {!isLoading && (
            <ExperienceItemCarousel
              offerIds={experienceIds}
              sectionId={sectionId}
              ctaCard={
                <CarouselCTACard key="ctaCard">
                  <ExperienceSearchModalCTA
                    tripId={tripId}
                    sectionId={sectionId}
                    onClick={hideModal}
                  />
                </CarouselCTACard>
              }
            />
          )}
        </VerticalSpacer>
      </Modal>
      <TextButton
        kind="secondary"
        size="medium"
        className={className}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          showModal()
        }}
      >
        View more offers
      </TextButton>
    </>
  )
}

export default ViewNearbyExperiencesCta
